import {
    HTTP
} from '@/utilities/http-common';

export default {
    namespaced: true,
    state: {
        count: 0
    },
    getters: {},
    mutations: {
        setCount(state, count) {
            state.count = count;
        },
        getCount(state) {
            return state.count;
        }
    },
    actions: {
        setPregnantPastDueCount({
            commit
        }, count) {
            commit('setCount', count);
        },
        getPregnantPastDueCount() {
            return HTTP.get('/kenya/subjects_pregnant/get_past_due_count');
        }
    },
}